import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .header {
    display: flex;
    justify-content: space-between;
    .wrapper {
      display: flex;
      gap: 10px;
    }
  }

  .AlertsCard {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }

  .map-wrapper {
    width: 100%;
  }

  .map-container {
    width: 100%;
    height: 100%;
  }
  
  .widgets-container {
    display: flex;
    background-color: ${(props) => props.theme.colors.widget_background};
    border-radius: 12px;
    margin-bottom: 20px;
    overflow: hidden;    

    .statistics-container {
      height: 632px;
      min-width: 380px;
      position: relative;

      &:has(.report-btn) {
        &:hover .report-btn {
          opacity: 0.8;
        }
      }

      .report-btn {
        position: absolute;
        top: 16px;
        right: 16px;
        border: none;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        opacity: 0;
        transition: opacity 0.3s;
      }
    }

    &>div:not(:last-child) {
      border-right: 1px solid ${(props) => props.theme.colors.outline};
    }
  }

  .notice-invalid-alerts {
    font-size: 13px;
    cursor: default;
    color: ${(props) => props.theme.colors.red};
  }
`;

export default { Wrapper };
